import { MouseEventHandler, createElement } from 'react';
import { HOC } from 'src/shared/componentBuilder';
import { omit } from 'lodash';
import { useConnectCatalogItem } from './useConnectCatalogItem';

interface ConnectCatalogItemClickProps {
  disabled?: boolean;
  catalogItemId: number;
  onClick?: MouseEventHandler<HTMLElement>;
}

const arrOfInternalKeys: Array<keyof ConnectCatalogItemClickProps> = ['catalogItemId'];

export const withConnectCatalogItemClick: HOC<ConnectCatalogItemClickProps> = (component) => (props) => {
  const [connectFeature, isLoading] = useConnectCatalogItem();
  const onClick: MouseEventHandler<HTMLElement> = async (event) =>
    connectFeature(props.catalogItemId).then((res) => res.tap(() => props.onClick?.(event)));

  return createElement(component, { ...omit(props, ...arrOfInternalKeys), onClick, disabled: isLoading || props.disabled });
};
